import React, {useEffect} from "react";
import {useSwipeableMarketsQuickbetX} from "../../../hooks/useSwipeableMarketsQuickbetX";
import {SMI, SwipedMarket, operatorPlaceholders, hiddenOperatorsSlider} from "../../helpers/helpers";
import LanguageSwitcher from "../../../../i18n/LanguageSwitcher";
import {UnifiedCardsComponentQuickbetX} from "./UnifiedCardsComponentQuickbetX";
import './QuickbetSwipeableMarkets.css';
import {useTranslation} from "react-i18next";
import '../../../Quickbet/helpers/quickbet.css';
import BootstrapCarousel from "../../../Carousel/Carousel";
import BritePayments from "../../../Brite/BritePayments";
import BriteIframe from "../../../Brite/BriteIframe";
import PaystackIframe from "../../../Paystack/PaystackIframe";
import PaystackPayments from "../../../Paystack/PaystackPayments";
import StakeList from "../../../Quickbet/Components/StakeList";
import {Dropdown} from "react-bootstrap";
const toAbsoluteUrl = (pathname: string) => process.env.PUBLIC_URL + pathname;

const QuickbetXSwipeableMarkets: React.FC <SMI> = ({
                                                       initPaystack,
                                                       hidePaystack,
                                                       clearPaystackSession,
                                                       paystackToken,setHidePaystack,
      sessionToken,
      selectedMarkets,
      makeMarketVisible,
      showPaymentBlock,
      highlightOdds,
      marketsCount,
      setShowSettingsModal,
      onSwipeEventIndex,
      skipEvent,
      eventToShow,
      clearBriteSession,
      triggerRedirectToTrack,
      markets,
      isAuth,
      ticketSummary,
      stakeBet,
      initBrite,
      psp,
      id,
      styles,
      language,
      languages,
      setPrice,
      setStake,
        price,
      operator,
      data,
      atag,
    rtag,
      currency,
      handeTest,
      handleChangeNumber}) => {
    const {
        swipedMarkets,
        childRefs,
        swiped,
        swipe,
        goBack,
        outOfFrame,
        feedback,
        marketsDEV,
        currentIndex
    } = useSwipeableMarketsQuickbetX(markets, skipEvent, makeMarketVisible, onSwipeEventIndex);
    const { t } = useTranslation();
    const oddsProgress = Math.min(
        (ticketSummary.total_odds / marketsCount.minTicketOdds) * 100,
        100
    );
    const eventsProgress = Math.min(
        (selectedMarkets.length / marketsCount.minTicketEvents) * 100,
        100
    );
    useEffect(() => {
        handeTest(swipedMarkets.length > 0 ? swipedMarkets: []);
    }, [swipedMarkets]);

    let isDisplaying = showPaymentBlock ? true : false;

    const placeholder = operator && operatorPlaceholders[operator]
        ? operatorPlaceholders[operator]
        : t('quickbet.priceBlock.inputPhonePlaceholder');
    return (
        <div>
            <div className="container-fluid quickbet-swipe"
                 style={{
                     color: styles.colors.fontColor,
                     fontSize: styles.fonts.mainFontSize,
                     fontFamily: styles.fonts.fontFamily,
                     backgroundColor: styles.colors.mainBgColor,
                     minHeight: '100vh',
                     height: '100%'
                 }}
            >
                <div className="d-flex flex-column flex-md-row justify-content-center">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div className="card-xl-stretch">
                            <div className="card-header bold border-0 mt-3">
                                <div className="logo-wrapper">
                                    <img
                                        alt="Logo"
                                        src={toAbsoluteUrl(`/assets/img/logo_${operator}.webp`)}
                                        onError={(e) => {
                                            e.currentTarget.src = toAbsoluteUrl('/assets/img/betstack_logo_lite.webp');
                                        }}
                                        className="h-40px app-sidebar-logo-default"
                                        style={{
                                            width: '210px',
                                            height: '100%',
                                            display: 'block',
                                            margin: '0 auto',
                                            marginBottom: '5px'
                                        }}
                                    />
                                    <div className="dropdown-wrapper">
                                        <Dropdown align="end">
                                            <Dropdown.Toggle variant="link" id="dropdown-basic"
                                                             className="settings-btn"
                                                             style={{color: styles.colors.buttonBGColor}}>
                                                <i className="fa-solid fa-cog"></i>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu className="custom-dropdown"
                                                           style={{backgroundColor: styles.colors.blockBgColor}}>
                                                <Dropdown.Item
                                                    as="div"
                                                    style={{
                                                        backgroundColor: "transparent",
                                                        color: styles.colors.fontColor,
                                                        "--hover-bg": styles.colors.buttonBGColor,
                                                    } as React.CSSProperties}
                                                    className="custom-dropdown-item"
                                                >
                                                    <a
                                                        href={`/quickbetx/${id}${atag ? `?atag=${encodeURIComponent(atag)}` : ''}${rtag ? `?rtag=${encodeURIComponent(rtag)}` : ''}`}
                                                        className='click_mode'
                                                        style={{
                                                            color: styles.colors.fontColor,
                                                            fontSize: '10px',
                                                            fontFamily: styles.fonts.fontFamily,
                                                        }}
                                                    >
                                                        <i className="fa-brands fa-centercode"
                                                           style={{fontSize: styles.fonts.titleFontSize}}/>
                                                        <div className="text mt-2 text-uppercase">
                                                            {t('quickbet.ticketBlock.goToClick')}
                                                        </div>
                                                    </a>
                                                </Dropdown.Item>
                                                {
                                                    setShowSettingsModal ?
                                                        <Dropdown.Item
                                                            as="div"
                                                            style={{
                                                                backgroundColor: "transparent",
                                                                color: styles.colors.fontColor,
                                                                "--hover-bg": styles.colors.buttonBGColor,
                                                            } as React.CSSProperties}
                                                            className="custom-dropdown-item"
                                                        >
                                                            <a
                                                                onClick={() => setShowSettingsModal(true)}
                                                                className='click_mode'
                                                                style={{
                                                                    color: styles.colors.fontColor,
                                                                    fontSize: '10px',
                                                                    fontFamily: styles.fonts.fontFamily,
                                                                }}
                                                            >
                                                                <i className="fa-solid fa-cog" style={{fontSize: styles.fonts.titleFontSize}}/>
                                                                <div className="text mt-2">
                                                                    {t('quickbet.markets.betSettings')}
                                                                </div>
                                                            </a>
                                                        </Dropdown.Item>
                                                        : null

                                                }
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                {
                                    language || languages.length > 0 ?
                                        <LanguageSwitcher operator={operator} language={language}
                                                          languages={languages}/>
                                        : null
                                }
                                {feedback && (
                                    <div className={`text-center feedback feedback-${feedback.direction}`}
                                         style={{
                                             fontFamily: styles.fonts.titleFontFamily,
                                             backgroundColor: styles.colors.blockBgColor
                                         }}
                                    >
                                        {
                                            feedback.direction !== 'up' ?
                                                <>
                                                    {t(`bets.${feedback.text.side}`)} {feedback.text.line_name ?
                                                    <span
                                                        style={{marginLeft: '5px'}}>{feedback.text.line_name}</span> : null}
                                                    <br/>
                                                    {feedback.text.odds}
                                                </>
                                                : <div>{t(feedback.text.side)}</div> // Використовуємо дані з feedback
                                        }
                                    </div>
                                )}
                            </div>
                            <div className="card-body p-0">
                                {
                                    !showPaymentBlock ?
                                        <div className={`swipeable-container ${
                                            !isDisplaying ? 'fade-in' : 'fade-out'
                                        }`}
                                             style={{
                                                 flexDirection: "column",
                                                 alignItems: "center",
                                                 paddingBottom: '55px',
                                             }}>
                                            <UnifiedCardsComponentQuickbetX
                                                operator={operator}
                                                highlightOdds={highlightOdds}
                                                currentIndex={currentIndex}
                                                styles={styles}
                                                markets={marketsDEV}
                                                swipedMarkets={swipedMarkets}
                                                childRefs={childRefs}
                                                onSwipe={swiped}
                                                onCardLeftScreen={outOfFrame}
                                                swipe={swipe}
                                                skipEvent={skipEvent}
                                                eventToShow={eventToShow}
                                            />
                                        </div>
                                        : null
                                }
                                {
                                    swipedMarkets.length === markets.length || showPaymentBlock ?
                                        <div
                                            className={`card-rounded mt-3 position-relative card-px py-3 mb-3 rounded ${
                                                isDisplaying ? 'fade-in' : 'fade-out'
                                            }`}
                                            style={{
                                                backgroundColor: styles.colors.blockBgColor,
                                                color: styles.colors.fontColor,
                                                minHeight: '450px'
                                            }}
                                        >
                                            <div className="card-body">
                                                {
                                                    data.prices.length > 0 ?
                                                        <p className='text-center text-uppercase rounded p-2 mb-3'
                                                           style={{
                                                               color: styles.colors.fontTitleColor,
                                                               backgroundColor: styles.colors.blockTitleBgColor,
                                                               width: '95%',
                                                               margin: '0 auto',
                                                           }}>
                                                            {t('jackpot.form.price')}: {price} {currency}
                                                        </p>
                                                        :
                                                        <p className='text-center text-uppercase'
                                                           style={{
                                                               color: styles.colors.fontTitleColor,
                                                               backgroundColor: styles.colors.blockTitleBgColor,
                                                           }}>
                                                            {t('jackpot.form.freeticket')}
                                                        </p>
                                                }
                                                {
                                                    psp?.some(item => item === 'brite') ? (
                                                            <>
                                                                {
                                                                    setStake && setPrice ?
                                                                        <StakeList
                                                                            operator={operator}
                                                                            styles={styles}
                                                                            stakes={data.stakes}
                                                                            prices={data.prices}
                                                                            setPrice={setPrice}
                                                                            setStake={setStake}
                                                                            isOpen={data.open_stake}
                                                                        />
                                                                        : null
                                                                }
                                                                <BritePayments styles={styles}
                                                                               initBrite={initBrite}
                                                                />
                                                            </>
                                                        ): psp?.some((item) => item === 'paystack') && !hidePaystack ? (
                                                            <>
                                                                {
                                                                    setStake && setPrice ?
                                                                        <StakeList
                                                                            operator={operator}
                                                                            styles={styles}
                                                                            stakes={data.stakes}
                                                                            prices={data.prices}
                                                                            setPrice={setPrice}
                                                                            setStake={setStake}
                                                                            isOpen={data.open_stake}
                                                                        />
                                                                        : null
                                                                }
                                                                <PaystackPayments
                                                                    styles={data.template}
                                                                    initPaystack={initPaystack}
                                                                    setHidePaystack={setHidePaystack}
                                                                    placeholder={placeholder}
                                                                    handleChangeNumber={handleChangeNumber}
                                                                    isAuth={isAuth}
                                                                />
                                                            </>
                                                        )  :
                                                        (
                                                            <>
                                                                {
                                                                    setStake && setPrice ?
                                                                        <StakeList
                                                                            operator={operator}
                                                                            styles={styles}
                                                                            stakes={data.stakes}
                                                                            prices={data.prices}
                                                                            setPrice={setPrice}
                                                                            setStake={setStake}
                                                                            isOpen={data.open_stake}
                                                                        />
                                                                        : null
                                                                }
                                                                {
                                                                    !isAuth ?
                                                                        <div className="from-block">
                                                                            <input
                                                                                type="tel"
                                                                                className='phone'
                                                                                id="tel"
                                                                                required
                                                                                maxLength={12}
                                                                                minLength={9}
                                                                                name="msisdn"
                                                                                placeholder={placeholder}
                                                                                onChange={(event) => {
                                                                                    handleChangeNumber(event.target.value)
                                                                                }}
                                                                                style={{
                                                                                    "--placeholder-color": styles.colors.fieldsFontColor,
                                                                                    backgroundColor: styles.colors.fieldsBgColor,
                                                                                    color: styles.colors.fieldsFontColor,
                                                                                    border: `1px solid ${styles.colors.fontColor}`,
                                                                                } as React.CSSProperties}
                                                                            />
                                                                        </div>
                                                                        : null
                                                                }
                                                                <div className="d-grid gap-2 col-6 mx-auto">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-lg"
                                                                        style={{
                                                                            backgroundColor: styles.colors.buttonBGColor,
                                                                            color: styles.colors.buttonFontColor,
                                                                            border: 'none'
                                                                        }}
                                                                        onClick={() => {
                                                                            stakeBet()
                                                                        }}
                                                                    >
                                                                        {t('jackpot.form.placeBet')}
                                                                    </button>
                                                                    {
                                                                        psp?.some((item) => item === 'paystack') ?
                                                                            <div
                                                                                style={{
                                                                                    textTransform: 'uppercase',
                                                                                    textDecoration: 'underline',
                                                                                    textAlign: 'center',
                                                                                }}
                                                                                onClick={() => setHidePaystack()}
                                                                            >
                                                                                {t('paystack.changeMethod')}
                                                                            </div>
                                                                            : null
                                                                    }
                                                                    <div
                                                                        className='list-group-item pt-2 pb-2 text-center'
                                                                        style={{borderColor: styles.colors.buttonBGColor}}>
                                                                        <div
                                                                            className="fw-bold">
                                                                            {t('quickbet.ticketBlock.price')}: {(ticketSummary.price).toFixed(2)} {currency}
                                                                        </div>
                                                                        <div className="separator"
                                                                             style={{borderColor: styles.colors.fontColor}}></div>
                                                                        <div
                                                                            className="">{t('quickbet.ticketBlock.exerciseTax')}:
                                                                            : {(ticketSummary.ext_amount).toFixed(2)} {currency}</div>
                                                                        <div
                                                                            className="">{t('quickbet.ticketBlock.stakeAfterTax')}: {(ticketSummary.stake).toFixed(2)} {currency}</div>
                                                                        <div
                                                                            className="">Total
                                                                            Odds: {(ticketSummary.total_odds).toFixed(2)}</div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                }
                                            </div>
                                            {
                                                !hiddenOperatorsSlider.includes(operator) ?
                                                    <div style={{
                                                        width: '95%',
                                                        margin: '0 auto',
                                                    }}>
                                                        <BootstrapCarousel style={styles}/>
                                                    </div>
                                                    : null
                                            }
                                        </div>
                                        : null
                                }
                                {
                                    swipedMarkets.length > 0 ?
                                        <button className='btn border previous-btn mt-2'
                                                style={{
                                                    display: 'block',
                                                    width: "90%",
                                                    margin: '0 auto',
                                                    backgroundColor: styles.colors.buttonBGColor,
                                                    color: styles.colors.buttonFontColor,
                                                }}
                                                onClick={goBack}>
                                            {t('jackpot.ticketSummary.backBtn')}
                                        </button>
                                        : null
                                }
                                {
                                    swipedMarkets.length > 0 ?
                                        <>

                                            <div
                                                className="card-rounded mt-3 position-relative card-px py-2 p-2 rounded mt-2 ticketFrom"
                                                style={{
                                                    backgroundColor: styles.colors.blockBgColor,
                                                }}
                                            >
                                                <h4
                                                    className='text-center rounded title p-1'
                                                    style={{
                                                        color: styles.colors.fontTitleColor,
                                                        fontSize: styles.fonts.titleFontSize,
                                                        fontFamily: styles.fonts.titleFontFamily,
                                                        backgroundColor: styles.colors.blockTitleBgColor,
                                                        textTransform: 'uppercase',
                                                        textAlign: 'center'
                                                    }}
                                                >{t('jackpot.ticketSummary.jackpotSummaryBets')}</h4>
                                                <ul style={{
                                                    listStyle: 'none',
                                                    padding: '0'
                                                }}>
                                                    {swipedMarkets.map((item: SwipedMarket, index: number) => (
                                                        <li key={index}
                                                            style={{
                                                                textAlign: 'center',
                                                            }}
                                                            className='rounded border mt-1'
                                                        >
                                                            {t(`markets.${item.market_code}`)}<br/>
                                                            {item.home_team.name} vs {item.away_team.name} <br/>
                                                            {t(`bets.${item.bet_name}`)}
                                                            : {item.odds}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                        :
                                        <div
                                            className="card-rounded position-relative card-px py-2 p-2 rounded mt-2 ticketFrom"
                                            style={{
                                                backgroundColor: styles.colors.blockBgColor,
                                            }}
                                        >
                                            <h4
                                                className='text-center rounded title p-1'
                                                style={{
                                                    color: styles.colors.fontTitleColor,
                                                    fontSize: styles.fonts.titleFontSize,
                                                    fontFamily: styles.fonts.titleFontFamily,
                                                    backgroundColor: styles.colors.blockTitleBgColor,
                                                    textTransform: 'uppercase',
                                                    textAlign: 'center'
                                                }}
                                            >
                                                {t('jackpot.ticketSummary.jackpotSwipeYourBets')}
                                            </h4>
                                        </div>
                                }
                            </div>
                            {
                                operator && operator === 'acme' ?
                                    <div
                                        className="d-flex align-items-center border border-dashed rounded mb-2 payment-block"
                                        style={{
                                            backgroundColor: styles.colors.blockTitleBgColor,
                                        }}>
                                        <div className='text-center text-uppercase rounded title p-1'
                                             style={{
                                                 color: styles.colors.fontTitleColor,
                                                 fontSize: styles.fonts.titleFontSize,
                                                 backgroundColor: styles.colors.blockTitleBgColor,
                                                 fontFamily: styles.fonts.titleFontFamily,
                                             }}>{t('jackpot.ticketSummary.titlePaymentBlock')}</div>
                                        <div className="payment-block">
                                            <img src={toAbsoluteUrl('/assets/operators/airtel.png')}
                                                 className="mobile-operator"
                                                 alt="airtel"
                                                 style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/at.png')}
                                                 className="mobile-operator"
                                                 alt="at"
                                                 style={{borderColor: styles.colors.fontColor}}
                                            />
                                            <img src={toAbsoluteUrl('/assets/operators/celtiis.png')}
                                                 className="mobile-operator"
                                                 alt="celtiis"
                                                 style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/halo.png')}
                                                 className="mobile-operator"
                                                 alt="halo" style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/mixx.png')}
                                                 className="mobile-operator"
                                                 alt="mix" style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/momo.png')}
                                                 className="mobile-operator"
                                                 alt="momo" style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/movitel.png')}
                                                 className="mobile-operator"
                                                 style={{borderColor: styles.colors.fontColor}}
                                                 alt="movitel"/>
                                            <img src={toAbsoluteUrl('/assets/operators/movo.png')}
                                                 className="mobile-operator"
                                                 alt="movo" style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/mpesa.png')}
                                                 className="mobile-operator"
                                                 style={{borderColor: styles.colors.fontColor}}
                                                 alt="mpesa"/>
                                            <img src={toAbsoluteUrl('/assets/operators/orangemoney.png')}
                                                 className="mobile-operator"
                                                 style={{borderColor: styles.colors.fontColor}}
                                                 alt="orangemoney"/>
                                            <img src={toAbsoluteUrl('/assets/operators/telecel.png')}
                                                 className="mobile-operator"
                                                 style={{borderColor: styles.colors.fontColor}}
                                                 alt="telecel"/>
                                            <img src={toAbsoluteUrl('/assets/operators/tnm.png')}
                                                 className="mobile-operator"
                                                 alt="tnm" style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/vodacom.png')}
                                                 className="mobile-operator"
                                                 style={{borderColor: styles.colors.fontColor}}
                                                 alt="vodacom"/>
                                            <img src={toAbsoluteUrl('/assets/operators/wave.png')}
                                                 className="mobile-operator"
                                                 alt="wave" style={{borderColor: styles.colors.fontColor}}/>
                                            <img src={toAbsoluteUrl('/assets/operators/zamtel.png')}
                                                 className="mobile-operator"
                                                 style={{borderColor: styles.colors.fontColor}}
                                                 alt="zamtel"/>
                                        </div>
                                    </div>
                                    : null
                            }
                            {
                                psp?.some((item) => item === 'brite') ?
                                    <BriteIframe triggerRedirectToTrack={triggerRedirectToTrack}
                                                 sessionToken={sessionToken} clearBriteSession={clearBriteSession}/>
                                    : null
                            }
                            {
                                psp?.some((item) => item === 'paystack') ?
                                    <PaystackIframe triggerRedirectToTrack={triggerRedirectToTrack} sessionToken={paystackToken}
                                                    clearPaystackSession={clearPaystackSession}/>
                                    : null
                            }
                            <p className='text-end'>{atag ? atag : null}</p>
                            {rtag?
                            <p className='text-end'>{rtag}</p>
                            : null
                            }
                            <div
                                style={{
                                    position: "fixed",
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    backgroundColor: styles.colors.blockBgColor,
                                    textAlign: "center",
                                    boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
                                    zIndex: 1,
                                    opacity: .9,
                                    borderTopLeftRadius: '10px',
                                    borderTopRightRadius: '10px'
                                }}
                            >

                                <div>
                                    {oddsProgress < 100 && (
                                        <div className='m-2'>
                                            <strong
                                                style={{
                                                    paddingTop: '10px',
                                                    color: styles.colors.fontColor,
                                                    fontSize: styles.fonts.mainFontSize,
                                                    fontFamily: styles.fonts.titleFontFamily,
                                                    textTransform: "uppercase",
                                                    textAlign: "center",
                                                }}
                                            >
                                                Total
                                                Odds: {ticketSummary.total_odds.toFixed(2)} / {marketsCount.minTicketOdds}
                                            </strong>

                                            <div className="progress"
                                                 style={{height: "20px", backgroundColor: '#e9ecef'}}>
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${oddsProgress}%`,
                                                        backgroundColor: styles.colors.buttonFontColor,
                                                        color: styles.colors.buttonBGColor,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {`${oddsProgress.toFixed(0)}%`}
                                                </div>
                                            </div>

                                        </div>
                                    )}
                                </div>
                                <div className="mt-3">
                                    {eventsProgress < 100 && (
                                        <div className='m-2 mb-3'>
                                            <strong
                                                style={{
                                                    color: styles.colors.fontColor,
                                                    fontSize: styles.fonts.mainFontSize,
                                                    fontFamily: styles.fonts.titleFontFamily,
                                                    textTransform: "uppercase",
                                                    textAlign: "center",
                                                }}
                                            >
                                                Events: {selectedMarkets.length} / {marketsCount.minTicketEvents}
                                            </strong>
                                            <div className="progress"
                                                 style={{height: "20px", backgroundColor: '#e9ecef'}}>
                                                <div
                                                    className="progress-bar"
                                                    role="progressbar"
                                                    style={{
                                                        width: `${eventsProgress}%`,
                                                        backgroundColor: styles.colors.buttonFontColor,
                                                        color: styles.colors.buttonBGColor,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {`${eventsProgress.toFixed(0)}%`}
                                                </div>
                                            </div>

                                        </div>
                                    )}

                                    {oddsProgress === 100 && eventsProgress === 100 && makeMarketVisible && (
                                        <div className="text-center my-3">
                                            <button
                                                onClick={() => makeMarketVisible(true)}
                                                style={{
                                                    backgroundColor: styles.colors.buttonBGColor,
                                                    color: styles.colors.buttonFontColor,
                                                    padding: '10px 20px',
                                                    border: 'none',
                                                    borderRadius: '8px',
                                                    fontSize: styles.fonts.buttonFontSize,
                                                    textTransform: 'uppercase',
                                                    display: isDisplaying ? 'none' : "block",
                                                    width: '80%',
                                                    margin: '0 auto',
                                                }}
                                            >
                                                {t('quickbet.priceBlock.betNow')}
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuickbetXSwipeableMarkets;
